
















import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';

// Components
import TextField from '@/components/Form/TextField.vue';

// Mixins
import UpdateClaim from '@/mixins/Staff/Claims/UpdateClaim';

// Validations
import { email } from 'vuelidate/lib/validators';

@Component({
	name: 'UpdateAssignee',
	components: {
		TextField,
	},
	validations: {
		assignee: {
			email,
		},
	},
})
export default class UpdateAssignee extends Mixins(UpdateClaim) {
	@Prop() public claimData: any;
	public assignee: string;
	public claimId: string;
	public claimStatus: string;
	private editing: boolean;

	constructor() {
		super();

		this.editing = false;
		this.assignee = this.claimData.hasOwnProperty('assignee') ? this.claimData.assignee : '';
		this.claimId = this.claimData.hasOwnProperty('claim_id') ? this.claimData.claim_id : '';
		this.claimStatus = this.claimData.hasOwnProperty('claim_status')
			? this.claimData.claim_status
			: '';
	}
}
